import {
  NotificationBridge,
  type NotificationPermissionState,
  type ShowNotificationOptions,
} from "@bso/shared";

import type { NotificationAdapter } from "./types";

export class WebNotificationAdapter implements NotificationAdapter {
  readonly supportsScheduling = false;
  private readonly bridge = new NotificationBridge({ isWeb: true });

  async getPermission(): Promise<NotificationPermissionState> {
    return this.bridge.getPermission();
  }

  async requestPermission(): Promise<boolean> {
    return this.bridge.requestPermission();
  }

  async show(title: string, options?: ShowNotificationOptions): Promise<void> {
    await this.bridge.show(title, options);
  }

  async cancelAll(): Promise<void> {
    // No OS-scheduled reminders exist on the web — nothing to cancel.
  }
}
